import IMask from "imask";

export function phoneMask(element) {
    IMask(element, {
        mask: [
            {
                mask: "(00) 0000-0000",  // Telefone fixo (8 dígitos)
            },
            {
                mask: "(00) 00000-0000",  // Celular (9 dígitos)
            }
        ]
    });
}
